<div class="dashboard-shimmer">

  <!-- STAT CARDS -->
  <div class="stats-grid">

    @for (item of [1, 2, 3, 4]; track item) {
      <div class="stat-card">

        <div class="stat-card-header">
          <div class="skeleton text title"></div>
          <div class="skeleton circle stat-icon"></div>
        </div>

        <div class="skeleton text stat-number"></div>
        <div class="skeleton text stat-description"></div>

      </div>
    }

  </div>


  <!-- MIDDLE -->
  <div class="middle-grid">

    <!-- CHART -->
    <div class="dashboard-card chart-card">

      <div class="card-header">

        <div class="heading">
          <div class="skeleton text heading-title"></div>
          <div class="skeleton text heading-description"></div>
        </div>

        <div class="skeleton button"></div>

      </div>


      <div class="chart">

        <div class="chart-y-axis">
          <div class="skeleton text axis-value"></div>
          <div class="skeleton text axis-value"></div>
          <div class="skeleton text axis-value"></div>
          <div class="skeleton text axis-value"></div>
          <div class="skeleton text axis-value"></div>
        </div>

        <div class="chart-content">

          <div class="grid-lines">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div class="bars">

            <div class="bar-group">
              <div class="skeleton bar bar-1"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-2"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-3"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-4"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-5"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-6"></div>
              <div class="skeleton text bar-label"></div>
            </div>

            <div class="bar-group">
              <div class="skeleton bar bar-7"></div>
              <div class="skeleton text bar-label"></div>
            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- SUMMARY -->
    <div class="dashboard-card summary-card">

      <div class="skeleton text summary-heading"></div>

      <div class="donut-wrapper">
        <div class="skeleton donut"></div>
      </div>

      <div class="summary-list">

        @for (item of [1, 2, 3]; track item) {
          <div class="summary-row">

            <div class="summary-left">
              <div class="skeleton circle indicator"></div>
              <div class="skeleton text summary-label"></div>
            </div>

            <div class="skeleton text summary-value"></div>

          </div>
        }

      </div>

    </div>

  </div>


  <!-- BOTTOM -->
  <div class="bottom-grid">

    <!-- RECENT ACTIVITY -->
    <div class="dashboard-card activity-card">

      <div class="card-header">
        <div class="skeleton text section-heading"></div>
        <div class="skeleton text small-link"></div>
      </div>

      <div class="activity-list">

        @for (item of [1, 2, 3, 4, 5]; track item) {
          <div class="activity-row">

            <div class="skeleton circle avatar"></div>

            <div class="activity-details">
              <div class="skeleton text activity-title"></div>
              <div class="skeleton text activity-description"></div>
            </div>

            <div class="skeleton text activity-time"></div>

          </div>
        }

      </div>

    </div>


    <!-- TABLE -->
    <div class="dashboard-card table-card">

      <div class="card-header">

        <div class="skeleton text section-heading"></div>

        <div class="skeleton button table-button"></div>

      </div>

      <div class="table-wrapper">

        <div class="table-header">
          <div class="skeleton text column-heading large"></div>
          <div class="skeleton text column-heading"></div>
          <div class="skeleton text column-heading"></div>
          <div class="skeleton text column-heading"></div>
        </div>


        @for (item of [1, 2, 3, 4, 5]; track item) {

          <div class="table-row">

            <div class="person">

              <div class="skeleton circle table-avatar"></div>

              <div class="skeleton text person-name"></div>

            </div>

            <div class="skeleton text table-text"></div>

            <div class="skeleton text table-text short"></div>

            <div class="skeleton pill"></div>

          </div>

        }

      </div>

    </div>

  </div>

</div>
